const SITE_NAME = "Eusébio News";

const DEFAULT_DESCRIPTION =
  "Portal de notícias do Eusébio e região: política, cidade, esportes, cultura e o que acontece no Ceará.";

/** Origem canônica do portal — sempre prioriza env (evita www vs apex no Helmet). */
export function getPublicSiteOrigin(): string {
  const fromEnv = (import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined)?.trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;
  // Em produção build sem env, force o host canônico (não use window — causa mismatch GSC).
  if (import.meta.env.PROD) {
    return "https://eusebionewsoficial.com.br";
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "https://eusebionewsoficial.com.br";
}

/** URL canônica absoluta (pathname sem query/hash, salvo override). */
export function buildCanonicalUrl(pathname: string, explicit?: string): string {
  if (explicit) return explicit;
  const origin = getPublicSiteOrigin();
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  if (path === "/") return `${origin}/`;
  return `${origin}${path.replace(/\/+$/, "")}`;
}

export function formatPageTitle(title?: string, siteName: string = SITE_NAME): string {
  const page = title?.trim();
  if (!page) return siteName;
  // Evita "Eusébio News | Eusébio News"
  if (page.toLocaleLowerCase("pt-BR") === siteName.toLocaleLowerCase("pt-BR")) {
    return siteName;
  }
  if (page.toLocaleLowerCase("pt-BR").endsWith(` | ${siteName.toLocaleLowerCase("pt-BR")}`)) {
    return page;
  }
  return `${page} | ${siteName}`;
}

export function resolveMetaDescription(description?: string | null, fallback: string = DEFAULT_DESCRIPTION): string {
  const value = description?.trim();
  if (!value) return fallback;
  // Taglines muito curtas prejudicam SEO — usa fallback mais completo
  if (value.length < 50) return fallback;
  return value;
}

export { SITE_NAME, DEFAULT_DESCRIPTION };
